module.exports = __webpack_public_path__ + "img/blue_132.9ad2ad12.png";